/**
 * La lista de lo pendiente: una tarjeta por cosa, con su botón para ir a hacerla.
 *
 * La usan la hoja de la campana y la pantalla de Inicio. **El botón es la tarjeta
 * entera**: en el móvil se pulsa con el pulgar, y un botón pequeño al final de una
 * frase es justo lo que no se acierta.
 */
import { Icono } from '@/shared/ui/Icono';
import type { Pendiente } from '@/shared/ui/pendientes/tipos';

export function ListaDePendientes({
  pendientes,
  alIr,
}: {
  pendientes: readonly Pendiente[];
  alIr: (destino: string) => void;
}) {
  if (pendientes.length === 0) {
    return (
      <div className="pendientes-al-dia" role="status">
        <Icono nombre="hecho" tamano={28} />
        <div>
          <strong>Todo al día</strong>
          <p>No hay nada pendiente. Cuando lo haya, aparecerá aquí.</p>
        </div>
      </div>
    );
  }

  return (
    <ul className="pendientes">
      {pendientes.map((p) => {
        const dentro = (
          <>
            <span className="pendiente-icono" aria-hidden="true">
              <Icono nombre={p.icono} tamano={20} />
            </span>
            <span className="pendiente-texto">
              <strong>{p.titulo}</strong>
              <span>{p.detalle}</span>
            </span>
          </>
        );
        const destino = p.destino;

        return (
          <li key={p.clave}>
            {destino ? (
              <button
                type="button"
                className={`pendiente pendiente-${p.gravedad}`}
                onClick={() => alIr(destino)}
              >
                {dentro}
                <span className="pendiente-accion">
                  <span className="pendiente-verbo">{p.accion}</span>
                  <Icono nombre="flecha" tamano={16} />
                </span>
              </button>
            ) : (
              <div className={`pendiente pendiente-${p.gravedad}`}>
                {dentro}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
